export function isWebAuthnSupported(): boolean {
  return (
    typeof window !== 'undefined' &&
    typeof window.PublicKeyCredential !== 'undefined' &&
    typeof (PublicKeyCredential as any).parseCreationOptionsFromJSON ===
      'function' &&
    typeof (PublicKeyCredential as any).parseRequestOptionsFromJSON ===
      'function'
  );
}
